import { configService } from './usersApi';

class ClusterManagementService {
  private fqdnToClusterMap: Map<string, string> | null = null;
  private clusterToFqdnMap: Record<string, string[]> | null = null;
  private fetchPromise: Promise<void> | null = null;

  constructor() {
    this.fetchMapping();
  }

  private async fetchMapping(): Promise<void> {
    if (this.fqdnToClusterMap) return;
    if (this.fetchPromise) return this.fetchPromise;

    this.fetchPromise = (async () => {
      try {
        const mapping = await configService.getClusterFqdnMapping();
        this.fqdnToClusterMap = new Map<string, string>();
        this.clusterToFqdnMap = mapping; // Also cache the direct mapping
        for (const clusterName in mapping) {
          for (const fqdn of mapping[clusterName]) {
            this.fqdnToClusterMap.set(fqdn, clusterName);
          }
        }
      } catch (error) {
        console.error('Failed to fetch and build cluster FQDN mapping:', error);
      } finally {
        this.fetchPromise = null;
      }
    })();
    
    await this.fetchPromise;
  }

  public async getClusterName(fqdn: string): Promise<string> {
    if (!this.fqdnToClusterMap) {
      await this.fetchMapping();
    }

    if (!this.fqdnToClusterMap) {
      // Fetch failed, return original fqdn
      return fqdn;
    }

    return this.fqdnToClusterMap.get(fqdn) || fqdn;
  }

  public async getClusterFqdnMapping(): Promise<Record<string, string[]>> {
    if (!this.clusterToFqdnMap) {
      await this.fetchMapping();
    }
    return this.clusterToFqdnMap || {};
  }
}

export const clusterManagementService = new ClusterManagementService();
